<dynamic-form
  [apiName]="apiName"
  [label]="label"
  [areaName]="areaName"
  [group]="formGroup"
  [model]="model"
  [columns]="columns"
  (cancelChange)="cancel()"
  (submitChange)="save()"
  [saveLabel]="'ClientApp.FrontOffice.Parties.FilterDriversByCode.Print' | translate">
  <ng-container class="content">
    <div class="filter-code-dialog">
      <ssg-input
        name="StartCode"
        [label]="'ClientApp.FrontOffice.Parties.FilterDriversByCode.FromCode' | translate"
        [group]="formGroup"
        [disabled]="false"
        userClass="select-sm"
        required="false"
        textType="number">
      </ssg-input>
      <ssg-input
        name="EndCode"
        [label]="'ClientApp.FrontOffice.Parties.FilterDriversByCode.UpToCode' | translate"
        [group]="formGroup"
        [disabled]="false"
        userClass="select-sm"
        required="false"
        textType="number">
      </ssg-input>
    </div>
  </ng-container>
</dynamic-form>
